import "./SetupScreen.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";

import Modal from "react-bootstrap/Modal";
import RocketImg from "../../../../assets/images/onboardingImages/rocket.gif";
import { useDispatch, useSelector } from "react-redux";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { storeUser } from "../../../../redux/users/usersSlice";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { fetchUser } from "../../../../helpers/helper";
import { useAtom } from "jotai";
import { globalCurrentPageTitle } from "../../../../store/globalstore";
import {
  resolveCommunityRecommendedPermissionType,
  cacheRecommendedPermissionType,
} from "../../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";

const NoLinkMemberSetupScreen = ({ setShowSetupModal, selectedCard }) => {
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle,
  );
  const [buttonText, setButtonText] = useState("Ok, let's go!");
  const navigate = useNavigate();
  const api = useApi();
  const handleClose = () => {
    navigate(
      `/${location.pathname.includes("cmWithNoLink") ? "cmWithNoLink" : "member"}/marketPlace`,
      { replace: true },
    );
    setShowSetupModal(false);
    setShow(false);
  };

  const JoinCommunityAndBecomeMember = async () => {
    try {
      const response = await api(
        "post",
        `NoLinkMember/convertNoLinkMemberToMember`,
        {
          communityId: selectedCard?._id,
        },
      );

      if (response?.status) {
        const recommended =
          resolveCommunityRecommendedPermissionType(selectedCard);
        if (recommended) {
          cacheRecommendedPermissionType(selectedCard?._id, recommended);
        }
        if (selectedCard?.disPlayName || selectedCard?.name) {
          sessionStorage.setItem(
            "recommendedPermissionCommunity",
            selectedCard?.disPlayName || selectedCard?.name
          );
        }
        await fetchUser(api, dispatch, storeUser);
        setShowSetupModal(false);
        setCurrentPageTitle("Dashboard");
        navigate(`/member/onboarding/view`, { replace: true });
      }
    } catch (error) {
      console.error("🚀 -> handleSignup -> error:", error);
    }
  };
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal setupScreen"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow">
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={crossBlack} />
          </button>
          <div className="onboardingContentBox">
            <img src={RocketImg} alt="" className="rocketImg" />
            <p className="title">Join our copy trading</p>
            <p className="desc">Just a few clicks and you'll be set up</p>

            <BubbleSvgButton
              className="NextBtn"
              onClick={JoinCommunityAndBecomeMember}
              text={buttonText}
              type="button"
              variant="green"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
            {/* <div>
              <BubbleSvgButton
                className="NextBtn"
                onClick={handleVerifyMyTrade}
                text={
                  user?.verifiedmyTrade.payment
                    ? "Verify Again"
                    : "Verify A Trade"
                }
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                mainDivStyle={{
                  width: "275px",
                  height: "55px",
                }}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NoLinkMemberSetupScreen;
